import React from 'react';
export function Footer() {
  return <footer className="bg-dark-900 py-10 px-4 border-t border-primary/30 text-center" data-id="element-97">
      <div className="max-w-4xl mx-auto" data-id="element-98">
        <h2 className="text-2xl font-bold text-primary mb-3" data-id="element-99">
          🌿 BIBLIOTECADIGITAL.ONLINE™
        </h2>
        <p className="text-cream/80 text-base md:text-lg mb-2" data-id="element-100">
          El método de desarrollo cognitivo infantil N°1 para familias
          hispanohablantes.
        </p>
        <p className="text-cream/60 italic mb-6" data-id="element-101">
          Porque criar niños enfocados, creativos y seguros no debería costarte
          cada tarde de tu vida.
        </p>

        <div className="flex flex-col md:flex-row justify-center items-center gap-3 text-cream/70 text-sm mb-6" data-id="element-102">
          <span data-id="element-103">📧 soportebibliodigital@gmail.com</span>
          <span className="hidden md:inline" data-id="element-104">·</span>
          <span data-id="element-105">🌐 www.bibliotecadigital.online</span>
        </div>

        <p className="text-cream/40 text-xs mb-6" data-id="element-106">
          © BibliotecaDigital.online™ 2026 — Todos los derechos reservados.
          Prohibida la reproducción y redistribución sin autorización expresa.
        </p>

        <p className="text-lg md:text-xl italic text-cream font-semibold" data-id="element-107">
          🌿 "La próxima tarde puede ser diferente."
        </p>
      </div>
    </footer>;
}